import { NEC } from 'constants/globalConstants';
import { PRIVILEGES } from 'utils/globalConst';

export const handleSubmit = (
  {
    typeAssurance,
    numPolice,
    numAdhesion,
    product,
    ppr,
    matricule,
    dateEffet,
    drpp,
    membershipNumber = '',
    organization,
  }: any,
  { props }: any,
) =>
  props.addNewContract({
    type: typeAssurance,
    numPolice,
    numAdhesion:
      typeAssurance === PRIVILEGES.AMC ? membershipNumber : numAdhesion,
    codeProduit: product,
    ppr: ppr,
    matricule: matricule,
    dateEffet: dateEffet,
    organisme: organization?.policyNumber ?? '',
    drpp,
    canal: NEC,
  });
